
import { Component, Vue } from 'vue-property-decorator';
@Component({
  name: 'paclTopLeft'
})
export default class PaclTopLeft extends Vue {

}
